module.exports = "/img/_/_/_/assets/images/creeper/book/common//11.jpg?97c5a129b66d1940be90397366d94f2e";